/*
|--------------------------------------------------------------------------
| Navigation
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.navigation = {
	"init": function(){
		this.removeDuplicateLinks();
	},
	"removeDuplicateLinks": function(){
		var linkMatches 	= 0,
			navDomArr		= [$("#toprail-nav-left .dropdown-menu li"),$("#drawer-nav-main-more .subnav li")],
			commonJS		= __gh__webApp.common;

		function removeDupes(arr){
			for(i=0;i<arr.length;i++){
				var linkArray	= [];
				arr[i].each(function(){
					var $this 		= $(this),
						link 		= $this.find('a').attr('href'),
						title		= $this.find('a').text(),
						linkTitle	= link+","+title;

					if(commonJS.inArray(linkTitle,linkArray)){
						$(this).remove();
					}else {
						linkArray.push(linkTitle);
					}

				});
			}
		}

		removeDupes(navDomArr);
	}

};